var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.843,
    height: 72.979,
    viewBox: "0 0 76.843 72.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "currencies",
    transform: "translate(0 -12.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_93_",
    transform: "translate(0 12.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_94---Forex",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_591_",
    d: "M57.345,44.886c-.355,0-.7.037-1.052.055a20.484,20.484,0,1,0-33.753-.014c-.347-.018-.693-.041-1.042-.041A20.484,20.484,0,1,0,39.421,75.267,20.484,20.484,0,1,0,57.345,44.886ZM21.5,33.363A17.965,17.965,0,1,1,36,50.943a20.693,20.693,0,0,0-9.774-5.492A17.729,17.729,0,0,1,21.5,33.363Zm17.93,22.123a19.7,19.7,0,0,0-1.042-1.693c.346.017.687.054,1.036.054s.7-.037,1.058-.055A19.9,19.9,0,0,0,39.428,55.487ZM21.5,83.294A17.924,17.924,0,1,1,38.053,58.527a20.244,20.244,0,0,0,0,13.687A18.02,18.02,0,0,1,21.5,83.294Zm35.848,0A18.027,18.027,0,0,1,40.614,71.806a17.788,17.788,0,0,1,3.528-18.518,20.219,20.219,0,0,0,9.789-5.505,17.688,17.688,0,0,1,3.413-.337,17.924,17.924,0,1,1,0,35.848Z",
    transform: "translate(-1 -12.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_590_",
    d: "M97.09,268.88a1.067,1.067,0,0,0,2.134,0c0-2.637-2.312-4.829-5.334-5.254v-2.214a1.067,1.067,0,0,0-2.134,0v2.214c-3.022.427-5.334,2.617-5.334,5.254s2.312,4.829,5.334,5.254V280.5c-1.835-.358-3.2-1.6-3.2-3.087a1.067,1.067,0,0,0-2.134,0c0,2.637,2.312,4.829,5.334,5.254v2.214a1.067,1.067,0,1,0,2.134,0v-2.214c3.022-.427,5.334-2.617,5.334-5.254s-2.312-4.829-5.334-5.254v-6.368C95.724,266.151,97.09,267.393,97.09,268.88Zm-8.535,0c0-1.487,1.366-2.729,3.2-3.087v6.175C89.92,271.609,88.555,270.367,88.555,268.88Zm8.535,8.535c0,1.487-1.366,2.729-3.2,3.087v-6.175C95.724,274.686,97.09,275.927,97.09,277.415Z",
    transform: "translate(-72.325 -220.656)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_589_",
    d: "M302.651,288.024a5.877,5.877,0,0,1,4.819,2.671,1.039,1.039,0,1,0,1.708-1.185,7.927,7.927,0,0,0-6.528-3.564,8.449,8.449,0,0,0-7.828,6.235H292.26a1.039,1.039,0,0,0,0,2.078h2.132c-.033.342-.054.688-.054,1.039s.021.7.054,1.039H292.26a1.039,1.039,0,0,0,0,2.078h2.564a8.449,8.449,0,0,0,7.828,6.235,7.927,7.927,0,0,0,6.528-3.564,1.039,1.039,0,0,0-1.708-1.185,5.877,5.877,0,0,1-4.819,2.671,6.25,6.25,0,0,1-5.625-4.156h5.625a1.039,1.039,0,0,0,0-2.078h-6.164a7.674,7.674,0,0,1,0-2.078h6.164a1.039,1.039,0,1,0,0-2.078h-5.625A6.25,6.25,0,0,1,302.651,288.024Z",
    transform: "translate(-245.573 -242.807)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_588_",
    d: "M188.562,82.377a7.189,7.189,0,0,0,6.771-.025.97.97,0,1,0-.991-1.668,5.222,5.222,0,0,1-4.874-.022,5.564,5.564,0,0,0-4.8-.485,33.7,33.7,0,0,0,.448-4.589h5.84a.97.97,0,1,0,0-1.94h-5.819V71.331a4.365,4.365,0,1,1,8.729,0,.97.97,0,0,0,1.94,0,6.3,6.3,0,0,0-12.609,0v2.317h-1.94a.97.97,0,1,0,0,1.94h1.91a31.857,31.857,0,0,1-.912,6.663.97.97,0,0,0,.942,1.2.847.847,0,0,0,.113-.007,1.077,1.077,0,0,0,.725-.44C185.225,81.6,186.706,81.394,188.562,82.377Z",
    transform: "translate(-150.904 -54.255)",
    fill: "#61ce65"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.b4bfd6ad3bedfe64c323fd9834e26915.svg";
export { ForwardRef as ReactComponent };